<!--  -->
<template>
  <div>
    <div class="collapse-commen-style alone-commen-style">
      <!-- 考试成绩 -->
      <Collapse v-model="collapseActiveNameScore" accordion v-if="isOverviewStatus" @on-change="getPlanScoreList">
          <Panel name="score">
              <div class="myplan-collapse-big-title" @click.stop>
                <Row>
                  <Col span="4"><div class="dis-flex"><span class="title-first">考试成绩</span><span class="icon-add-box commen-icon-margt"  @click="planAddTargetScore('add','')" style="padding-left:10px;"><Icon type="ios-add-circle-outline" class="icon-add" /></span></div></Col>
                </Row>
                <!-- <Row v-else>
                  <Col span="4"><span class="title-first">{{item.name}}</span></Col>
                  <Col span="13"><myplan-todo-progress :strokeColor="strokeColor"></myplan-todo-progress></Col>
                    <Col span="3" style="height:5px;"><span ></span></Col>
                  <Col span="1"><span class="icon-add-box"  @click="planAddTargetScore('add','')" style="padding-left:32px;"><Icon type="ios-add-circle-outline" class="icon-add" /></span></Col>
                </Row> -->
              </div>
              <div slot="content">
                  <Collapse accordion  v-model="collapseMiddleActiveNameScore" class="inner-collapse" @on-change="getToDoList('SCORE')">
                    <Panel :name="(targetScoreItem.id).toString()" v-for="(targetScoreItem,targetScoreIndex) in targetListScore" :key="'SCORE'+targetScoreIndex" >
                        <div class="myplan-collapse-big-title" @click.stop>
                            <Row>
                              <Col span="4"><span class="title-second">{{planScoreTypeEnums['planScoreTypeFilter'](targetScoreItem.type)}}</span></Col>
                              <Col span="2"><span  @click="desModel(targetScoreItem,'SCORE')"><Icon type="ios-information-circle-outline" class="icon-ios-add" /></span></Col>
                              <Col span="3"><span>{{targetScoreItem.score?(targetScoreItem.score):0}}/{{targetScoreItem.target?(targetScoreItem.target):0}}</span></Col>
                              <Col span="4"><span>{{targetScoreItem.phasesName}}</span></Col>
                              <Col span="6"><myplan-todo-progress :strokeColor="strokeColor" :sum="targetScoreItem.target" :finishCount="targetScoreItem.score?targetScoreItem.score:0"></myplan-todo-progress></Col>
                              <Col span="2" style="height:5px;"><span ></span></Col>
                              <Col span="1" v-if="(targetScoreItem.createrType)==='MENTEE'"><span class="second-inner-icon" @click="planAddTargetScore('edit',targetScoreItem)"><Icon type="ios-create-outline" class="icon-box" /></span></Col>
                              <Col span="1"><span class="second-inner-icon" @click="planAddTodos(targetScoreItem,'SCORE','add')"><Icon type="ios-add-circle-outline" class="icon-box" /></span></Col>
                              <Col span="1" v-if="(targetScoreItem.createrType)==='MENTEE'"><span class="second-inner-icon"  @click="planDelete(targetScoreItem.id,'SCORE','target')"><Icon type="ios-trash-outline" class="icon-box" /></span></Col>
                            </Row>
                        </div>
                        <div slot="content">
                          <div class="myplan-collapse-content" @click.stop>
                            <div class="myplan-collapse-content-list">
                              <Row v-for='(innerItem,innerIndex) in toDosListScore' :key="innerIndex" class="dis-15">
                                <Col span="8">
                                   <Checkbox v-model="innerItem.finish" @on-change="planMenteeFinishTodos(innerItem.id,innerIndex,'SCORE')" v-if="!isEdit"></Checkbox>
                                  <span :class="{'checkbox-line':innerItem.finish}" class="color_333 margin_left_2">{{innerItem.name}}</span>
                                </Col>
                                <Col span="6">
                                  <span class="color_333">{{innerItem.phasesName}}&nbsp;&nbsp;{{getTime(innerItem.completionTime)}}</span>
                                </Col>
                                <Col span="1" v-if="(innerItem.createrType)==='MENTEE'"><span class="second-inner-icon"  @click="planAddTodos(innerItem,'SCORE','edit')"><Icon type="ios-create-outline" class="icon-box" /></span></Col>
                                <Col span="1" v-if="(innerItem.createrType)==='MENTEE'"><span class="second-inner-icon"  @click="planDelete(innerItem.id,'SCORE','todo')"><Icon type="ios-trash-outline" class="icon-box" /></span></Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                    </Panel>
                  </Collapse>
              </div>
          </Panel>
      </Collapse>
       <!-- 非考试成绩 -->
      <Collapse v-model="collapseActiveName" accordion  v-if="isOverviewStatus" @on-change="getTargetList">
          <Panel :name="(item.id).toString()"  v-for='(item,index) in categoryList' :key="index">
              <div class="myplan-collapse-big-title" @click.stop>
                <Row>
                  <Col span="24"><div class="dis-flex"><span class="title-first">{{item.name}}</span> <span class="icon-add-box commen-icon-margt" @click="planAddTarget(item,'add')" style="padding-left:10px;"><Icon type="ios-add-circle-outline" class="icon-add" /></span></div></Col>
                  <Col span="3">
                  <div class="dis-flex">

                    <!-- <span class="second-inner-icon" @click="planAddCategory(item,'edit')" style="margin:0 15px;"><Icon type="ios-create-outline"  class="icon-box"></Icon></span>
                    <span class="second-inner-icon" @click="planDelete(item.id,'OTHER','category')"><Icon type="ios-trash-outline" class="icon-box"></Icon></span> -->
                  </div>

                  </Col>
                </Row>
              </div>
              <div slot="content">
                  <Collapse accordion  v-model="collapseMiddleActiveName" class="inner-collapse" @on-change="getToDoList('OTHER')">
                    <Panel :name="(targetItem.id).toString()" v-for="(targetItem,targetIndex) in targetList" :key="targetIndex+'OTHER'">
                        <div class="myplan-collapse-big-title" @click.stop>
                            <Row>
                              <Col span="4"><span class="title-second">{{targetItem.name}}</span></Col>
                              <Col span="2"><span @click="desModel(targetItem,'OTHER')"><Icon type="ios-information-circle-outline" class="icon-ios-add" /></span></Col>
                              <Col span="3"><span>{{targetItem.finishCount}}/{{targetItem.sum}}</span></Col>
                              <Col span="4"><span> {{targetItem.phasesName}}</span></Col>
                              <Col span="6"><myplan-todo-progress :strokeColor="strokeColor" :sum="targetItem.sum" :finishCount="targetItem.finishCount"></myplan-todo-progress></Col>
                              <Col span="2" style="height:5px;"><span ></span></Col>
                              <Col span="1" v-if="(targetItem.createrType)==='MENTEE'"><span class="second-inner-icon"  @click="planAddTarget(targetItem,'edit')"><Icon type="ios-create-outline" class="icon-box" /></span></Col>
                              <Col span="1"><span class="second-inner-icon"  @click="planAddTodos(targetItem,'OTHER','add')"><Icon type="ios-add-circle-outline" class="icon-box" /></span></Col>
                              <Col span="1" v-if="(targetItem.createrType)==='MENTEE'"><span class="second-inner-icon"  @click="planDelete(targetItem.id,'OTHER','target')"><Icon type="ios-trash-outline" class="icon-box" /></span></Col>
                            </Row>
                        </div>
                        <div slot="content">
                          <div class="myplan-collapse-content" @click.stop>
                            <div class="myplan-collapse-content-list">
                              <Row v-for='(innerItem,innerIndex) in toDosList' :key="innerIndex+'OTHER'" class="dis-15">
                                <Col span="8">
                                  <Checkbox v-model="innerItem.finish" @on-change="planMenteeFinishTodos(innerItem.id,innerIndex,'OTHER')" v-if="!isEdit"></Checkbox>
                                  <span :class="{'checkbox-line':innerItem.finish}" class="color_333 margin_left_2">{{innerItem.name}}</span>
                                </Col>
                                <Col span="6">
                                  <span class="color_333">{{innerItem.phasesName}}&nbsp;&nbsp;{{getTime(innerItem.completionTime)}}</span>
                                </Col>
                                <Col span="1" v-if="(innerItem.createrType)==='MENTEE'"><span class="second-inner-icon"  @click="planAddTodos(innerItem,'OTHER','edit')"><Icon type="ios-create-outline" class="icon-box" /></span></Col>
                                <Col span="1" v-if="(innerItem.createrType)==='MENTEE'"><span class="second-inner-icon"  @click="planDelete(innerItem.id,'OTHER','todo')"><Icon type="ios-trash-outline" class="icon-box" /></span></Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                    </Panel>
                  </Collapse>
              </div>
          </Panel>
      </Collapse>
    </div>
    <!-- 添加弹窗成绩 -->
    <div  class="common-modal-style" v-if="addModal">
        <zlr-modal v-model="addModal" class="common-modal-style-box" width="428px" :transfer="false" :mask-closable="false">
          <div slot="header">
            <span class="title">{{targetScoreEdit === 'add'?'添加考试成绩':'修改考试成绩'}}</span>
          </div>
          <div class="common-modal-style-main">
            <Form :model="formModal" :label-width="120" label-position="left" ref="formModal" :rules="rulesFormScoreTarget">
              <FormItem label="成绩类型" prop="type">
                  <Select v-model="formModal.type">
                      <Option :value="typeItem.value" v-for="typeItem in  planScoreTypeEnums['planScoreTypeEnum']" :key="typeItem.value">{{typeItem.label}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="目标" prop="target">
                  <Input v-model="formModal.target" placeholder="目标"></Input>
              </FormItem>
              <FormItem label="年级" prop="grade">
                  <Select v-model="formModal.grade" @on-change="planQueryPhasesListChangeTarget">
                      <Option :value="gradeItem.value" v-for="gradeItem in planPhaseGradeEunms['planPhaseGradeEnum']" :key="gradeItem.value">{{gradeItem.label}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="期待完成时间" prop="phasesId" v-if="phasesList.length > 0">
                  <Select v-model="formModal.phasesId">
                      <Option :value="phaseItem.id" v-for="phaseItem in phasesList" :key="phaseItem.id">{{phaseItem.name}}</Option>
                  </Select>
              </FormItem>
            </Form>
            <div class="common-modal-style-btn">
                <Button class="zlr-btn-default"
                        @click="addModal = false">取消</Button>
                <Button class="zlr-btn-primary"
                        @click="handleComformAdd('formModal')">确定</Button>
            </div>
          </div>
        </zlr-modal>
    </div>
    <!-- 添加弹窗类目 -->
    <div  class="common-modal-style" v-if="addModalCategory">
        <zlr-modal   v-model="addModalCategory" class="common-modal-style-box" width="428px" :transfer="false" :mask-closable="false">
          <div slot="header">
            <span class="title">添加规划事项</span>
          </div>
          <div class="common-modal-style-main">
            <Form :model="formModal" :label-width="120" label-position="left" ref="formModalCategory" :rules="rulesFormCategory">
              <FormItem label="名字" prop="name">
                  <Input v-model="formModal.name" placeholder="名字"></Input>
              </FormItem>
            </Form>
            <div class="common-modal-style-btn" slot="footer">
                <Button class="zlr-btn-default"
                        @click="addModalCategory = false">取消</Button>
                <Button class="zlr-btn-primary"
                        type="primary"
                        @click="handleComformAddCategory('formModalCategory')">确定</Button>
            </div>
          </div>
        </zlr-modal>
    </div>
    <!-- 添加目标 -->
    <div  class="common-modal-style" v-if="addModalTarget">
        <zlr-modal v-model="addModalTarget" class="common-modal-style-box" width="428px" :transfer="false" :mask-closable="false">
          <div slot="header">
            <span class="title">{{targetEdit === 'add'?'添加目标':'修改目标'}}</span>
          </div>
          <div class="common-modal-style-main">
            <Form :model="formModal" :label-width="120" label-position="left" ref="formModalTarget" :rules="rulesFormTarget">
              <FormItem label="名字" prop="name">
                  <Input v-model="formModal.name" placeholder="名字"></Input>
              </FormItem>
              <FormItem label="年级" prop="grade">
                  <Select v-model="formModal.grade" @on-change="planQueryPhasesListChangeTarget">
                      <Option :value="gradeItem.value" v-for="gradeItem in planPhaseGradeEunms['planPhaseGradeEnum']" :key="gradeItem.value">{{gradeItem.label}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="期待完成时间" prop="phasesId" v-if="phasesList.length > 0">
                  <Select v-model="formModal.phasesId">
                      <Option :value="phaseItem.id" v-for="phaseItem in phasesList" :key="phaseItem.id">{{phaseItem.name}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="描述">
                  <Input v-model="formModal.desc" placeholder="描述" type="textarea"></Input>
              </FormItem>
            </Form>
            <div class="common-modal-style-btn" slot="footer">
              <Button class="zlr-btn-default"
                      @click="addModalTarget = false">取消</Button>
              <Button class="zlr-btn-primary"
                      type="primary"
                      @click="handleComformAddTarget('formModalTarget')">确定</Button>
            </div>
          </div>
        </zlr-modal>
    </div>
    <!-- 添加todos -->
    <div  class="common-modal-style" v-if="addModalTodos">
        <zlr-modal v-model="addModalTodos" class="common-modal-style-box" width="428px" :transfer="false" :mask-closable="false">
          <div slot="header">
            <span class="title"> {{todosEdit === 'add'?'添加'+todosModalName+'':'修改Todos'}}</span>
          </div>
          <div class="common-modal-style-main">
            <Form :model="formModal" :label-width="135" label-position="left" ref="formModalTodos" :rules="rulesFormTodos">
              <FormItem label="名字" prop="name">
                  <Input v-model="formModal.name" placeholder="名字" type="textarea"></Input>
              </FormItem>
              <FormItem label="年级" prop="grade">
                  <Select v-model="formModal.grade" @on-change="planQueryPhasesListChange">
                      <Option  v-for="gradeItem in planPhaseGradeEunms['planPhaseGradeEnum']" :value="gradeItem.value" :key="gradeItem.value">{{gradeItem.label}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="期待完成时间" prop="parentId" v-if="phasesList.length>0">
                  <Select v-model="formModal.parentId">
                      <Option  v-for="phaseItem in phasesList" :value="phaseItem.id" :key="phaseItem.id+phaseItem.name">{{phaseItem.name}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="年份" prop="year">
                  <Select v-model="formModal.year" @on-change="planQueryPhasesListParentChange">
                      <Option  v-for="item in 6" :value="2020+item" :key="item">{{2020+item}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="月份" prop="month">
                  <Select v-model="formModal.month" @on-change="planQueryPhasesListParentChange">
                        <Option  v-for="item in 12" :value="0+item" :key="item">{{0+item}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="期待完成月份" prop="phasesId" v-if="phasesListParent.length>0">
                  <Select v-model="formModal.phasesId">
                       <Option  v-for="phaseItem in phasesListParent" :value="phaseItem.id" :key="phaseItem.id+phaseItem.name">{{phaseItem.name}}</Option>
                  </Select>
              </FormItem>
               <FormItem label="期待完成具体时间" prop="completionTime">
                  <DatePicker type="date" placeholder="期待完成具体时间" style="width: 200px" v-model="formModal.completionTime"   @on-change="dataTime"></DatePicker>
              </FormItem>
            </Form>
            <div class="common-modal-style-btn" slot="footer">
              <Button class="zlr-btn-default"
                      @click="addModalTodos = false">取消</Button>
              <Button class="zlr-btn-primary"
                      type="primary"
                      @click="handleComformAddTodos('formModalTodos')">确定</Button>
            </div>
          </div>
        </zlr-modal>
    </div>
    <!-- 添加备注弹窗 -->
    <div v-if="desModal">
      <Modal class="common-modal-style-box" width="428px" v-model="desModal" :transfer="false" :mask-closable="false" >
          <div slot="header">
            <span class="title">{{descInfo.name}}</span>
          </div>
          <div class="common-modal-style-main">
            <!-- <Form :model="formModal" :label-width="120" label-position="left" ref="formModalDesc" :rules="rulesFormCategory">
              <FormItem label="备注" prop="name">
                  <Input v-model="formModal.name" placeholder="Enter something..."></Input>
              </FormItem>
            </Form>
            <div class="common-modal-style-btn" slot="footer">
              <Button class="zlr-btn-default"
                      @click="desModal = false">取消</Button>
              <Button class="zlr-btn-primary"
                      type="primary"
                      @click="handleComformAddDesc('formModalDesc')">确定</Button>
            </div> -->
            <pre>{{descInfo.desc}}</pre>
          </div>
          <div slot="footer"></div>
      </Modal>
    </div>
    <!-- 删除弹窗 -->
    <div class="common-modal-style" v-if="deleteModal">
        <zlr-modal v-model="deleteModal" class="common-modal-style-box" width="428px">
          <div class="common-modal-style-main">
            <div class="delete-main-box">
             <span><Icon type="ios-alert" class="icon-color" /></span>
             <div class="delete-main">
               <strong>确认要删除这条信息吗？</strong>
               <span>删除后不可恢复</span>
             </div>
            </div>
            <div class="common-modal-style-btn">
              <Button class="zlr-btn-default"
                      @click="deleteModal = false">取消</Button>
              <Button class="zlr-btn-primary"
                      @click="handleComformDelete">确定</Button>
            </div>
          </div>
        </zlr-modal>
    </div>
 </div>
</template>
<script>
import ZlrModal from '_c/modal/modal'
import planPhaseGradeEunms from '@/enums/plan-phase-grade-enums'
import planScoreTypeEnums from '@/enums/plan-score-type-enums'
import { validateNum } from '@/libs/validator'
import { date2String } from '@/libs/tools'
import MyplanTodoProgress from './myplan-todo-progress'
import { planQueryScoreList, planQueryOtherTodosList, planQueryCategoryList, planQueryTargetList, planQueryScoreTodosList, planMenteeAddScore, planMenteeAddCategory, planMenteeModifyTarget, planMenteeAddTodos, planMenteeDeleteScore, planMenteeDeleteTodos, planMenteeDeleteTarget, planMenteeModifyScore, planMenteeModifyTodos, planMenteeModifyCategory, planDeleteCategory, planQueryPhasesList, planQueryPhasesListParent, planMenteeAddTarget, planMenteeFinishTodos } from '@/api/data-myplan'
export default {
  name: '',
  components: {
    MyplanTodoProgress,
    ZlrModal
  },
  props: ['isOverviewStatus'],
  data () {
    return {
      planPhaseGradeEunms,
      planScoreTypeEnums,
      collapseActiveName: '1',
      collapseMiddleActiveName: '',
      // 内部进度条颜色
      strokeColor: '#6589DD',
      // 弹出框
      deleteModal: false,
      addModal: false,
      // 表单弹窗
      formModal: {},
      rulesFormCategory: {
        name: [
          { required: true, message: '不为空' }
        ]
      },
      rulesFormScoreTarget: {
        type: [
          { required: true, message: '不为空' }
        ],
        target: [
          { required: true, message: '不为空' },
          { validator: validateNum }
        ],
        grade: [
          { required: true, message: '不为空' }
        ],
        phasesId: [
          { required: true, message: '不为空' }
        ]
      },
      rulesFormTarget: {
        name: [
          { required: true, message: '不为空' }
        ],
        grade: [
          { required: true, message: '不为空' }
        ],
        phasesId: [
          { required: true, message: '不为空' }
        ]
      },
      rulesFormTodos: {
        name: [
          { required: true, message: '不为空' }
        ],
        grade: [
          { required: true, message: '不为空' }
        ],
        parentId: [
          { required: true, message: '不为空' }
        ],
        year: [
          { required: true, message: '不为空' }
        ],
        month: [
          { required: true, message: '不为空' }
        ],
        phasesId: [
          { required: true, message: '不为空' }
        ]
      },
      // 添加类目
      addModalCategory: false,
      // 添加目标
      addModalTarget: false,
      categoryId: '',
      // 添加todos
      addModalTodos: false,
      targetId: '',
      todosType: '',
      // 时间选择
      cityList: [
        {
          value: 'New York',
          label: 'New York'
        },
        {
          value: 'London',
          label: 'London'
        }
      ],
      model1: '',
      // 考试成绩
      collapseActiveNameScore: '',
      collapseMiddleActiveNameScore: '',
      toDosList: [],
      categoryList: [],
      targetList: [],
      desModal: false,
      targetListScore: [],
      toDosListScore: [],
      desId: '',
      // 编辑
      targetScoreEdit: '',
      targetEdit: '',
      todosEdit: '',
      categoryEdit: '',
      // 阶段
      phasesList: [],
      phasesListParent: [],
      // 弹窗名字todos
      todosModalName: '',
      isEdit: false,
      // 备注
      descInfo: {
        desc: '',
        name: ''
      },
      // 删除
      deleteInfo: {
        id: '',
        type: '',
        kinds: ''
      }
    }
  },
  computed: {},
  mounted () {
    // 查询类目信息列表
    this.getCategoryList()
    // this.planQueryPhasesList()
  },
  methods: {
    // 阶段1选项
    planQueryPhasesList () {
      if (this.formModal.grade) {
        let data = {}
        data.grade = this.formModal.grade
        planQueryPhasesList(data).then(res => {
          if (res.code === 0) {
            this.phasesList = res.data.model
          }
        })
      } else {
        this.phasesList = []
      }
    },
    // 阶段2
    planQueryPhasesListParent () {
      if (this.formModal.year && this.formModal.month) {
        let data = {}
        data.year = this.formModal.year
        data.month = this.formModal.month
        planQueryPhasesList(data).then(res => {
          if (res.code === 0) {
            this.phasesListParent = res.data.model
          }
        })
      } else {

      }
    },
    planQueryPhasesListChange () {
      if (this.formModal.parentId) {
        this.phasesList = []
      }
      this.planQueryPhasesList()
    },
    planQueryPhasesListParentChange () {
      if (this.formModal.phasesId) {
        this.phasesListParent = []
      }
      this.planQueryPhasesListParent()
    },
    planQueryPhasesListChangeTarget () {
      if (this.formModal.grade) {
        this.phasesList = []
      }
      this.planQueryPhasesList()
    },
    // 完成时间
    dataTime (d) {
      this.formModal.completionTime = d
    },
    // 处理时间
    getTime (time) {
      return time ? date2String(time) : ''
    },
    // 查询成绩目标
    getPlanScoreList () {
      planQueryScoreList().then(res => {
        if (res.code === 0) {
          this.targetListScore = res.data.model
        }
      })
    },
    // 查询类目信息列表
    getCategoryList () {
      planQueryCategoryList().then(res => {
        if (res.code === 0) {
          this.categoryList = res.data.model
        }
      })
    },
    // 查询目标信息列表
    getTargetList () {
      this.collapseMiddleActiveName = ''
      this.toDosList = []
      if (this.collapseActiveName) {
        planQueryTargetList({ id: this.collapseActiveName[0] }).then(res => {
          if (res.code === 0) {
            this.targetList = res.data.model
          }
        })
      }
    },
    // 查询todos
    getToDoList (type) {
      if (type === 'OTHER') {
        if (this.collapseMiddleActiveName) {
          planQueryOtherTodosList({ id: this.collapseMiddleActiveName[0], type: 'OTHER' }).then(res => {
            if (res.code === 0) {
              this.toDosList = res.data.model
            }
          })
        }
      }
      if (type === 'SCORE') {
        if (this.collapseMiddleActiveNameScore) {
          planQueryScoreTodosList({ id: this.collapseMiddleActiveNameScore[0], type: 'SCORE' }).then(res => {
            if (res.code === 0) {
              this.toDosListScore = res.data.model
            }
          })
        }
      }
    },
    // 添加成绩目标
    planAddTargetScore (edit, item) {
      this.addModal = true
      this.targetScoreEdit = edit
      if (edit === 'edit') {
        this.phasesList = []
        this.formModal = Object.assign({}, item)
        this.formModal.grade = this.formModal.phasesGrade
        if (this.formModal.grade) {
          this.planQueryPhasesList()
        }
      }
      if (edit === 'add') {
        this.formModal = {}
      }
    },
    // 确认添加成绩目标的弹窗
    handleComformAdd (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formModal)
          // data.planningId = this.planningId
          if (this.targetScoreEdit === 'add') {
            planMenteeAddScore(data).then(res => {
              if (res.code === 0) {
                this.addModal = false
                this.getPlanScoreList()
              }
            })
          }
          if (this.targetScoreEdit === 'edit') {
            planMenteeModifyScore(data).then(res => {
              if (res.code === 0) {
                this.addModal = false
                this.getPlanScoreList()
              }
            })
          }
        } else {
        }
      })
    },
    // 添加类目
    planAddCategory (item, edit) {
      this.addModalCategory = true
      this.categoryEdit = edit
      if (edit === 'edit') {
        this.categoryId = item.id
        this.formModal = Object.assign({}, item)
      } else {
        this.formModal = {}
      }
    },
    // 确认提交类目
    handleComformAddCategory (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formModal)
          data.id = this.categoryId
          data.templateId = this.planningId
          if (this.categoryEdit === 'edit') {
            planMenteeModifyCategory(data).then(res => {
              if (res.code === 0) {
                this.getCategoryList()
                this.addModalCategory = false
              }
            })
          } else {
            planMenteeAddCategory(data).then(res => {
              if (res.code === 0) {
                this.getCategoryList()
                this.addModalCategory = false
              }
            })
          }
        } else {
          this.$zlr_message('验证错误', 'error')
        }
      })
    },
    // 添加目标
    planAddTarget (item, edit) {
      this.addModalTarget = true
      this.categoryId = item.id
      this.targetEdit = edit
      if (edit === 'edit') {
        this.phasesList = []
        this.formModal = Object.assign({}, item)
        this.formModal.grade = this.formModal.phasesGrade
        this.formModal.phasesId = this.formModal.phasesId
        if (this.formModal.grade) {
          this.planQueryPhasesList()
        }
      }
      if (edit === 'add') {
        this.formModal = {}
      }
    },
    handleComformAddTarget (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formModal)
          data.categoryId = this.categoryId
          if (this.targetEdit === 'add') {
            planMenteeAddTarget(data).then(res => {
              if (res.code === 0) {
                this.getTargetList()
                this.addModalTarget = false
              }
            })
          }
          if (this.targetEdit === 'edit') {
            planMenteeModifyTarget(data).then(res => {
              if (res.code === 0) {
                this.getTargetList()
                this.addModalTarget = false
              }
            })
          }
        } else {
          this.$zlr_message('验证错误', 'error')
        }
      })
    },
    // 添加todos
    planAddTodos (item, type, edit) {
      this.addModalTodos = true
      if (type === 'SCORE') {
        this.todosModalName = item.type
      } else {
        this.todosModalName = item.name
      }
      this.targetId = item.id
      this.todosType = type
      this.todosEdit = edit
      if (edit === 'edit') {
        this.phasesList = []
        this.phasesListParent = []
        this.formModal = Object.assign({}, item)
        this.formModal.completionTime = this.formModal.completionTime ? date2String(this.formModal.completionTime) : ''
        this.formModal.grade = this.formModal.phasesGrade ? this.formModal.phasesGrade : '0'
        if (this.formModal.grade) {
          this.planQueryPhasesList()
        }
        this.formModal.parentId = this.formModal.parentPhasesId ? this.formModal.parentPhasesId : 0
        this.formModal.year = Number(this.formModal.phasesYear)
        this.formModal.month = Number(this.formModal.phasesMonth)
        this.formModal.phasesId = this.formModal.phasesId
        if (this.formModal.year && this.formModal.month) {
          this.planQueryPhasesListParent()
        }
      }
      if (edit === 'add') {
        this.formModal = {}
      }
    },
    handleComformAddTodos (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formModal)
          data.targetId = this.targetId
          data.type = this.todosType
          if (this.todosEdit === 'add') {
            planMenteeAddTodos(data).then(res => {
              if (res.code === 0) {
                this.getToDoList(this.todosType)
                this.addModalTodos = false
              }
            })
          }
          if (this.todosEdit === 'edit') {
            planMenteeModifyTodos(data).then(res => {
              if (res.code === 0) {
                this.getToDoList(this.todosType)
                this.addModalTodos = false
              }
            })
          }
        } else {
          this.$zlr_message('验证错误', 'error')
        }
      })
    },
    // 添加备注
    desModel (item, type) {
      this.desModal = true
      this.desId = item.id
      this.todosType = type
      this.descInfo.desc = item.desc ? item.desc : '暂无数据'
      this.descInfo.name = item.name ? item.name : '备注'
    },
    handleComformAddDesc (name) {
      // this.$refs[name].validate((valid) => {
      //   if (valid) {
      //     let data = Object.assign({}, this.formModal)
      //     data.targetId = this.desId
      //     planAddTodos(data).then(res => {
      //       if (res.code === 0) {
      //         this.desModal = false
      //       }
      //     })
      //   } else {
      //     this.$Message.error('error')
      //   }
      // })
    },
    // 删除
    planDelete (id, type, kinds) {
      this.deleteModal = true
      this.deleteInfo.id = id
      this.deleteInfo.type = type
      this.deleteInfo.kinds = kinds
    },
    // 删除对话框
    handleComformDelete () {
      this.planDeleteModel(this.deleteInfo.id, this.deleteInfo.type, this.deleteInfo.kinds)
    },
    planDeleteModel (id, type, kinds) {
      // 删除成绩目标
      if (type === 'SCORE' && kinds === 'target') {
        planMenteeDeleteScore({ id: id }).then(res => {
          if (res.code === 0) {
            this.$zlr_message('删除成功', 'success')
            this.getPlanScoreList()
            this.deleteModal = false
          }
        })
      }
      // 删除目标
      if (type === 'OTHER' && kinds === 'target') {
        planMenteeDeleteTarget({ id: id }).then(res => {
          if (res.code === 0) {
            this.$zlr_message('删除成功', 'success')
            this.getTargetList()
            this.deleteModal = false
          }
        })
      }
      // 删除todos
      if (kinds === 'todo') {
        planMenteeDeleteTodos({ id: id }).then(res => {
          if (res.code === 0) {
            this.$zlr_message('删除成功', 'success')
            this.getToDoList(type)
            this.deleteModal = false
          }
        })
      }
      // 删除类目
      if (type === 'OTHER' && kinds === 'category') {
        planDeleteCategory({ id: id }).then(res => {
          if (res.code === 0) {
            this.$zlr_message('删除成功', 'success')
            this.getCategoryList()
            this.deleteModal = false
          }
        })
      }
    },
    // handleCancelDelete () {

    // },

    // 完成todo信息
    planMenteeFinishTodos (id, index, type) {
      let data = {}
      data.id = id
      if (type === 'SCORE') {
        data.finish = this.toDosListScore[index].finish
        planMenteeFinishTodos(data).then(res => {
          if (res.code === 0) {
            this.getToDoList(type)
            this.getPlanScoreList()
          }
        })
      } else {
        data.finish = this.toDosList[index].finish
        planMenteeFinishTodos(data).then(res => {
          if (res.code === 0) {
            this.getToDoList(type)
            this.getTargetList()
          }
        })
      }
    }
  }
}
</script>
<style lang="less">
  .alone-commen-style.collapse-commen-style{
    //复选框选中样式
    .ivu-checkbox-checked .ivu-checkbox-inner:after{
      border-color:#6589DD;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner{
      border-color:#6589DD;
      background-color: #E9EEF9;
    }
    // 折叠面板的样式
    .ivu-collapse{
      border:none;
      background-color:#FAFAFC;
    }
    .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
      display: flex;
      align-items: center;
      border-bottom:none;
      padding-left:0;
    }
    .ivu-collapse-content{
      background-color:#FAFAFC;
    }
    .ivu-collapse>.ivu-collapse-item{
      border-top:none;
      margin-bottom:0px;
    }
    >.ivu-collapse>.ivu-collapse-item{
     margin-bottom:30px;
    }
    .ivu-icon-ios-arrow-forward:before{
      content: "\F341";
    }
    .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header>i{
      color:#6589DD;
      font-size:28px;
      margin-top: -3px;
    }
    .inner-collapse.ivu-collapse{
      margin-left:22px;
    }
    .inner-collapse.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header{
      background-color:#FFFFFF;
      padding:11px 59px;
      margin-bottom: 16px;
      height:auto;
      line-height: 28px;
    }
    .inner-collapse.ivu-collapse>.ivu-collapse-item>.ivu-collapse-header>i{
      color:#D8D8D8;
    }
    .inner-collapse .ivu-collapse-content{
      margin-left:52px;
    }
    .inner-collapse .ivu-collapse-content-box{
       margin-bottom:0;
    }
}
// 表单label
.common-modal-style-box{
  .ivu-form .ivu-form-item-label{
    font-weight: bold;
  }
}
</style>
<style lang="less" scoped>
  .collapse-commen-style{
     .myplan-collapse-big-title{
        display: inline-block;
        width:96%;
    }
    .title-first{
      font-size:18px;
      font-weight: 600;
      color: #333333;
    }
    .icon-add-box {
      .icon-add{
        margin-left:15px;
        font-size:22px;
        color:#6589DD;
      }
    }
    .myplan-collapse-content-list {

    }
    .icon-ios-add{
      color:#6589DD;
      font-size:20px;
    }
    .title-second {
      font-size:16px;
      color:#333333;
    }
    .second-inner-icon{
      cursor: pointer;
      .icon-box{
        font-size:20px;
        color:#6589DD;
      }
    }
    .checkbox-line{
      text-decoration: line-through;
    }
  }
  .color_333{
    color:#333333;
  }
  // 公用弹窗
  .common-modal-style{
    &-main{
      padding:16px 33px;
    }
    &-btn{
      margin-top:10px;
      text-align: right;
      .zlr-btn-default{
        margin-right:28px;
      }
    }
  }
  .common-modal-style-box{
    .ivu-modal-header .title{
      font-size:16px;
      font-weight: bold;
      padding:0 30px;
    }
  }
  // 删除弹窗
  .delete-main-box{
    display: flex;
    .icon-color{
      color:#FAAD14;
      font-size:21px;
    }
    .delete-main{
      margin-left:18px;
      display:flex;
      flex-direction: column;
      strong{
        font-size:16px;
        padding-bottom:12px;
      }
      span{
        padding-bottom:12px;
      }
    }
  }
  .dis-flex{
    display: flex;
    align-items: center;
  }
  .margin_left_2{
    margin-left:10px;
  }
  .flex-style-commen{
    display: flex;
    align-items: center;
  }
  .commen-icon-margt{
    margin-top:-4px;
  }
</style>
